export type Testimonial = {
  quote: string
  name: string
}

export const testimonials: Testimonial[] = [
  {
    quote:
      "Choosing Limitlast for our digital marketing needs was the best decision we made. Their data-driven approach and constant optimization have yielded exceptional results, exceeding our expectations. We highly endorse their services.",
    name: 'Abdoulie Bojang',
  },
  {
    quote:
      "Limitlast transformed our brand identity with their exceptional design work. Their creativity and attention to detail captured our vision perfectly. It's been a pleasure collaborating with their talented team!",
    name: 'Baba Mbow',
  },
]
